const FILTER = document.querySelector('.vd-filter');
const CONTAINER = document.querySelector('.print--search-query');


const getSelectValues = (select) => {
	const result = [];
	const options = select && select.options;
  
	/**
	 * @see https://stackoverflow.com/questions/35969974/foreach-is-not-a-function-error-with-javascript-array
	 */

	//options.forEach((opt) => {

	[...options].forEach(function (opt) {
		if (opt.selected) {
			result.push(opt.text);
		}
	});

	return result;
}

const getRadioValues = (checkboxContainer) => {
	const result = [];
	const checkboxes = checkboxContainer.querySelectorAll('input[type="checkbox"]');

	checkboxes.forEach((item) => {
		if (item.checked) result.push(item.nextSibling.innerHTML);
	})

	return result;
} 

const generateSearchQueryList = () => {
	const inputs = FILTER.querySelectorAll('.form-control, .vd-filter__checkbox--multiple');

	inputs.forEach((el) => {
		const node = document.createElement('p');
		let label = document.querySelector(`label[for="${el.id}"]`);
		let value = el.value;

		if (el.classList.contains('vd-filter__checkbox--multiple')) {
			label = el.querySelector('.control-label');
			value = getRadioValues(el);
		}

		if (el.nodeName === 'SELECT') {
			value = getSelectValues(el);
		}
        
		node.innerHTML = `<strong>${label?.innerHTML}:</strong> <span>${value ? value : ''}</span>`;

		CONTAINER.appendChild(node);
	})

};

if (CONTAINER) {
	generateSearchQueryList();
}